import { Outlet } from "react-router-dom";
import ProductList from "./ProductList/ProductList";
import ProductForm from "./ProductForm/ProductForm";
import ProductMedia from "./ProductMedia/ProductMedia";
import { adminWarehouseRoutes } from "../Warehouse/warehouse-routes";
import SubOrders from "./SubOrders/SubOrders";
import SubOrderDetails from "./SubOrders/SubOrderDetails";
import { Returns } from "./Returns/Returns";
import { ReturnDetails } from "./Returns/ReturnDetails";

export const adminProductsRoutes = [
  {
    path: "products",
    element: Outlet,
    children: [
      {
        path: "",
        redirect: "list",
      },
      {
        path: "list",
        element: ProductList,
      },
      {
        path: "add",
        element: ProductForm,
      },
      {
        path: "edit/:id",
        element: ProductForm,
      },
      {
        path: "media/:id",
        element: ProductMedia,
      },
      ...adminWarehouseRoutes,
      {
        path: "sub-orders",
        element: SubOrders,
      },
      {
        path: "sub-orders/view/:id",
        element: SubOrderDetails,
      },
      {
        path: "returns",
        element: Returns,
      },
      {
        path: "returns/view/:id",
        element: ReturnDetails,
      },
    ],
  },
];
